import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IconComponent } from '@mode/capra';
import { SlackChannel } from '@mode/shared/contract-common';
import { NotificationType, Schedule } from '@mode/shared/schedules/contract';
import { SchedulableEntity } from './schedulable-entity';

@Component({
  selector: 'mode-delivery-info',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './delivery-info.component.html',
  styleUrls: ['./delivery-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeliveryInfoComponent implements OnChanges {
  @Input() schedule: Schedule = { frequency: 'daily', minute: 0, timeZone: 'UTC', hour: 0 };
  @Input() entity: SchedulableEntity = 'report';
  @Input() notifyType: NotificationType = 'none';
  @Input() numberOfSubscribers?: number;
  @Input() slackChannel?: SlackChannel;
  message = this._generateMessage();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['entity']?.currentValue) {
      this.message = this._generateMessage();
    }
  }

  private _generateMessage(): string {
    switch (this.entity) {
      case 'report':
        return 'This schedule will refresh all Report data';
      case 'sqlDataset':
        return 'This schedule will run the Dataset';
      case 'gsheetDataset':
        return 'This schedule will pull data in from the underlying Google Sheet';
    }
  }
}
